import React from "react";
import { auth } from "../firebase";
import firebase from "firebase";
// import { Button } from "@material-ui/core";

function SignIn() {
  function googleSignIn() {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }
  return (
    <div className="signPage">
      <button className="btn btn-large btn-info p-2" onClick={googleSignIn}>
        Sign In With Google
      </button>
    </div>
  );
}

export default SignIn;
